import { render, staticRenderFns } from "./YJSJy.vue?vue&type=template&id=aff33ae2&scoped=true&"
import script from "./YJSJy.vue?vue&type=script&lang=js&"
export * from "./YJSJy.vue?vue&type=script&lang=js&"
import style0 from "./YJSJy.vue?vue&type=style&index=0&id=aff33ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff33ae2",
  null
  
)

export default component.exports